import { mlvLogoAppBarCenter } from '../../../core/brand/mlvLogo.js';
import { esCuentaPremiumPerfil } from '../../../core/monetizacion/planes.js';
import { TRIAL_DIAS } from '../../../core/monetizacion/vendedorNiveles.js';
import { escapeHtml as esc } from '../../../core/ui/escapeHtml.js';
import { initialsFromNameEmail as initialsFrom } from '../../../core/ui/initials.js';
import { withBusyButton } from '../../../core/ui/withBusyButton.js';
import { mlvNavPng, mlvPng } from '../../../core/ui/mlvPngIcons.js';
import { isServiciosNavVisible } from '../../../core/config/mlvFeatureFlags.js';
import { mlvTrack } from '../../../core/telemetry/mlvTrack.js';
import { MLV_EVENTS } from '../../../core/telemetry/mlvEvents.js';

function wirePerfilAccionBusy(id, fn, labelBusy = 'Cargando…') {
  const el = document.getElementById(id);
  if (!el || typeof fn !== 'function') return;
  el.addEventListener('click', () => {
    void withBusyButton(el, async () => {
      await fn();
    }, { labelBusy });
  });
}

function iconBellPerfil() {
  return `<svg class="h-6 w-6 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" /></svg>`;
}

function iconChevron() {
  return `<svg class="w-5 h-5 text-slate-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>`;
}

function iconPencilPerfil() {
  return mlvPng('edit', 'h-6 w-6 shrink-0 object-contain', { w: 24, h: 24 });
}

function iconGrid() {
  return `<svg class="w-6 h-6 shrink-0 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25A2.25 2.25 0 0113.5 8.25V6zM3.75 15.75a2.25 2.25 0 012.25-2.25h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25v-2.25z" /></svg>`;
}

function iconPlusSquare() {
  return `<svg class="w-6 h-6 shrink-0 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 2.25h-9A2.25 2.25 0 005.25 4.5v15A2.25 2.25 0 007.5 21.75h9a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0016.5 2.25z" /><path stroke-linecap="round" stroke-linejoin="round" d="M12 8.25v7.5M8.25 12h7.5" /></svg>`;
}

function iconLogout() {
  return `<svg class="w-6 h-6 shrink-0 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" /></svg>`;
}

function iconPlusCircle() {
  return `<svg class="w-7 h-7 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path stroke-linecap="round" stroke-linejoin="round" d="M12 8.25v7.5M8.25 12h7.5" /></svg>`;
}

function iconCameraAvatar() {
  return `<svg class="h-4 w-4 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" /></svg>`;
}

function iconShieldAdmin() {
  return `<svg class="w-6 h-6 shrink-0 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 3l7.5 3v6c0 5.25-3.75 8.25-7.5 9-3.75-.75-7.5-3.75-7.5-9V6L12 3z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9.75 12l1.5 1.5 3-3"/></svg>`;
}

function iconRocketEmpuja() {
  return `<svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.281 5.119v4.8a6 6 0 007.281 5.119 14.98 14.98 0 0012.12-6.16 14.98 14.98 0 00-6.16-12.12z" /></svg>`;
}

/**
 * Pantalla de perfil (mobile-first) — La Victoria Market
 */
export function createPerfilPresenter({ render }) {
  function showPerfil({
    user,
    profile,
    isVerified,
    ventasCount = 0,
    /** @type {{ ventasEnVentana?: number, nivelEfectivo?: number, enTrialNivel5?: boolean, premioNivel5Etiqueta?: boolean } | null} */
    nivelResumen = null,
    ratingDisplay = '—',
    ratingSubline = '',
    onEditarPerfil,
    onMisPublicaciones,
    onPublicar,
    onLogout,
    onSearch,
    onExplorar,
    onVender,
    onCambiarFoto,
    showAdminPanel = false,
    onAdminPanel,
    onVerInfoExperienciaVendedor,
    onVerPlanPremiumProfesional,
    onComoFuncionaBarrio,
    onEmpujaComercio,
    onServiciosBarrio,
    onNotificaciones,
    notificacionesPendientesCount = 0,
    showInstalarApp = false,
    onInstalarApp,
  }) {
    const email = user?.email || '';
    const nombre =
      String(profile?.nombre || '').trim() ||
      String(user?.displayName || '').trim() ||
      email.split('@')[0] ||
      'Usuario';
    const avatarUrl = user?.photoURL || '';
    const initials = initialsFrom(nombre, email);
    const firstName = nombre.split(/\s+/)[0] || nombre;
    const esPremium = esCuentaPremiumPerfil(profile);
    mlvTrack(MLV_EVENTS.PERFIL_VER, {
      es_premium: Boolean(esPremium),
      verificado: Boolean(isVerified),
      nivel: Number(nivelResumen?.nivelEfectivo) || 0,
    });

    const avatarInner = avatarUrl
      ? `<img src="${esc(avatarUrl)}" alt="" class="h-full w-full object-cover" />`
      : `<div class="flex h-full w-full items-center justify-center bg-gradient-to-br from-[#0a5c5f] via-brand-primary to-emerald-900 text-3xl font-bold tracking-tight text-white shadow-inner">${esc(initials)}</div>`;

    const badgeVerified = isVerified
      ? `<span class="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-brand-secondary shadow-md ring-2 ring-white" title="Perfil verificado">
          <svg class="w-4 h-4 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
        </span>`
      : '';

    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-2 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <span class="h-10 w-10 shrink-0" aria-hidden="true"></span>
          ${mlvLogoAppBarCenter()}
          <button type="button" id="perfil-notif" class="relative ml-auto flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/60" aria-label="Notificaciones">
            ${iconBellPerfil()}
            <span id="perfil-notif-badge" class="absolute right-1 top-1 min-h-[1.1rem] min-w-[1.1rem] rounded-full bg-red-600 px-1 text-center text-[10px] font-bold leading-tight text-white ${
              notificacionesPendientesCount > 0 ? '' : 'hidden'
            }">${notificacionesPendientesCount > 0 ? esc(String(notificacionesPendientesCount)) : ''}</span>
          </button>
        </header>

        <main class="max-w-lg mx-auto px-4 pt-6">
          <div class="flex flex-col items-center text-center">
            <div class="relative mb-4 w-fit">
              <label class="group relative block h-28 w-28 cursor-pointer">
                <input type="file" id="perfil-foto-input" accept="image/*" class="sr-only" aria-label="Cambiar foto de perfil" />
                <div class="relative h-28 w-28 overflow-hidden rounded-full shadow-md ring-2 ring-white">
                  ${avatarInner}
                  <span class="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center bg-gradient-to-t from-black/55 to-transparent py-2 pt-8 text-[10px] font-semibold uppercase tracking-wide text-white opacity-0 transition group-hover:opacity-100 group-focus-within:opacity-100">
                    Tocá para cambiar
                  </span>
                </div>
                <span class="pointer-events-none absolute bottom-1 left-1 z-[1] flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-md ring-1 ring-slate-200/90" title="Foto de perfil">
                  ${iconCameraAvatar()}
                </span>
              </label>
              ${badgeVerified}
            </div>
            <p id="perfil-foto-hint" class="text-[11px] text-slate-400 -mt-1 mb-2 max-w-[280px]">Tocá la foto para subirla o cambiarla. Sin foto, ves tus iniciales.</p>
            <h2 class="font-heading text-xl font-bold text-slate-900">${esc(nombre)}</h2>
            <p class="mt-1 text-sm text-slate-500">${esc(email)}</p>
            ${
              nivelResumen && typeof nivelResumen.nivelEfectivo === 'number'
                ? `<div class="mt-3 flex flex-wrap justify-center gap-2">
              <span class="rounded-full bg-brand-primary/15 px-3 py-1 text-xs font-bold text-brand-primary ${
                nivelResumen.nivelEfectivo === 1 && !nivelResumen.enTrialNivel5
                  ? 'line-through decoration-slate-500 decoration-2 opacity-75'
                  : ''
              }">Nivel ${esc(String(nivelResumen.nivelEfectivo))}</span>
              ${
                nivelResumen.enTrialNivel5
                  ? '<span class="rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-900">Trial nivel 5</span>'
                  : ''
              }
              ${
                nivelResumen.premioNivel5Etiqueta
                  ? '<span class="rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-900">Premio Nivel 5</span>'
                  : ''
              }
            </div>`
                : ''
            }

            <div class="mt-6 grid w-full grid-cols-2 gap-3">
              <div class="rounded-2xl bg-brand-primary/10 px-4 py-3 text-center shadow-sm">
                <p class="text-2xl font-bold tabular-nums text-brand-primary">${esc(String(ventasCount))}</p>
                <p class="text-[10px] font-semibold uppercase tracking-wider text-slate-600">Ventas (30 d.)</p>
              </div>
              <div class="rounded-2xl bg-brand-primary/10 px-3 py-3 text-center shadow-sm">
                <p class="text-2xl font-bold tabular-nums text-brand-primary">${esc(ratingDisplay)}</p>
                <p class="text-[10px] font-semibold uppercase tracking-wider text-slate-600">Rating</p>
                ${
                  ratingSubline
                    ? `<p class="mt-1.5 text-[10px] leading-snug text-slate-500">${esc(ratingSubline)}</p>`
                    : ''
                }
              </div>
            </div>
            <p class="mt-2 text-center text-[11px] text-slate-400">Ventas: últimos 30 días. Rating: promedio de reseñas de compradores.</p>
          </div>

          <button type="button" id="perfil-empuja-comercio" class="mt-8 flex w-full items-center gap-4 rounded-2xl border border-amber-300/80 bg-gradient-to-br from-amber-50 via-white to-orange-50/90 p-4 text-left shadow-md ring-1 ring-amber-400/20 transition hover:brightness-[1.02]">
            <span class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 text-white shadow-md" aria-hidden="true">
              ${iconRocketEmpuja()}
            </span>
            <span class="min-w-0 flex-1">
              <span class="block font-heading text-base font-bold text-slate-900">Empujá tu comercio</span>
              <span class="mt-0.5 block text-xs leading-snug text-slate-600">Destacá un aviso o sumá visibilidad a tu negocio</span>
            </span>
            ${iconChevron()}
          </button>

          <div class="mt-8 space-y-3 px-0">
            ${
              typeof onServiciosBarrio === 'function'
                ? `<button type="button" id="perfil-servicios-barrio" class="flex w-full items-center justify-center gap-2 rounded-2xl border border-brand-primary/30 bg-brand-primary/5 px-4 py-3.5 text-sm font-semibold text-brand-primary shadow-sm transition hover:bg-brand-primary/10">
              Servicios del barrio (oficios)
            </button>`
                : ''
            }
            <button type="button" id="perfil-como-barrio" class="flex w-full items-center justify-center gap-2 rounded-2xl border border-dashed border-slate-300/90 bg-slate-50/90 px-4 py-3.5 text-sm font-semibold text-slate-800 shadow-sm transition hover:border-brand-primary/40 hover:bg-white">
              Cómo funciona el barrio: cupos, nivel y comisión
            </button>
          </div>

          <section class="mt-8">
            <p class="mb-3 text-xs font-semibold uppercase tracking-widest text-slate-500">Gestión de cuenta</p>
            ${
              showInstalarApp
                ? `<button type="button" id="perfil-instalar-pwa" class="mb-3 flex w-full items-center gap-4 rounded-2xl border border-emerald-200/90 bg-emerald-50/90 p-4 text-left shadow-sm transition hover:bg-emerald-100/80">
              <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-lg" aria-hidden="true">📲</span>
              <span class="min-w-0 flex-1">
                <span class="block font-semibold text-emerald-950">Instalar la app</span>
                <span class="block text-sm text-emerald-900/85">Acceso rápido desde la pantalla de inicio</span>
              </span>
              ${iconChevron()}
            </button>`
                : ''
            }
            <nav class="space-y-3">
              <button type="button" id="perfil-editar" class="flex w-full items-center gap-4 rounded-2xl border border-slate-200/90 bg-white p-4 text-left shadow-sm transition hover:bg-slate-50">
                <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-muted/60">${iconPencilPerfil()}</span>
                <span class="min-w-0 flex-1">
                  <span class="block font-semibold text-slate-900">Cambiar número de contacto</span>
                  <span class="block text-sm text-slate-500">Solo WhatsApp / teléfono</span>
                </span>
                ${iconChevron()}
              </button>
              <button type="button" id="perfil-mis-pubs" class="flex w-full items-center gap-4 rounded-2xl border border-slate-200/90 bg-white p-4 text-left shadow-sm transition hover:bg-slate-50">
                <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-muted/60">${iconGrid()}</span>
                <span class="min-w-0 flex-1">
                  <span class="block font-semibold text-slate-900">Mis publicaciones</span>
                  <span class="block text-sm text-slate-500">Ver, fotos y dar de baja</span>
                </span>
                ${iconChevron()}
              </button>
              <button type="button" id="perfil-publicar" class="flex w-full items-center gap-4 rounded-2xl border border-slate-200/90 bg-white p-4 text-left shadow-sm transition hover:bg-slate-50">
                <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-muted/60">${iconPlusSquare()}</span>
                <span class="min-w-0 flex-1">
                  <span class="block font-semibold text-slate-900">Publicar producto</span>
                  <span class="block text-sm text-slate-500">Nueva publicación en el barrio</span>
                </span>
                ${iconChevron()}
              </button>
              ${
                showAdminPanel
                  ? `<button type="button" id="perfil-admin-panel" class="flex w-full items-center gap-4 rounded-2xl border border-brand-primary/30 bg-brand-primary/5 p-4 text-left shadow-sm transition hover:bg-brand-primary/10">
                <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-muted/60">${iconShieldAdmin()}</span>
                <span class="min-w-0 flex-1">
                  <span class="block font-semibold text-slate-900">Panel admin</span>
                  <span class="block text-sm text-slate-500">Usuarios, planes y comisiones</span>
                </span>
                ${iconChevron()}
              </button>`
                  : ''
              }
              <button type="button" id="perfil-logout" class="flex w-full items-center gap-4 rounded-2xl border border-red-200 bg-red-50/90 p-4 text-left shadow-sm transition hover:bg-red-100/80">
                <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-red-100/80">${iconLogout()}</span>
                <span class="min-w-0 flex-1">
                  <span class="block font-semibold text-red-700">Cerrar sesión</span>
                  <span class="block text-sm text-red-600/90">Hasta pronto, ${esc(firstName)}</span>
                </span>
                ${iconChevron()}
              </button>
            </nav>
          </section>

          ${
            esPremium
              ? `<section class="mt-8 rounded-2xl border border-emerald-200/90 bg-emerald-50/60 p-5 shadow-sm">
            <h3 class="font-heading text-lg font-bold leading-snug text-emerald-950">Tu cuenta Premium</h3>
            <p class="mt-2 text-sm leading-relaxed text-emerald-900/90">
              Podés repasar niveles de vendedor y comisiones cuando quieras.
            </p>
            <div class="mt-4">
              <button type="button" id="perfil-beneficios" class="inline-flex w-full items-center justify-center rounded-full bg-brand-primary py-3 text-sm font-bold uppercase tracking-wide text-white shadow-md transition hover:brightness-95 sm:w-auto sm:px-8">
                Ver beneficios
              </button>
            </div>
          </section>`
              : `<section class="mt-8 overflow-hidden rounded-2xl bg-gradient-to-br from-brand-primary to-brand-primary/80 p-5 text-white shadow-lg">
            <h3 class="font-heading text-lg font-bold leading-snug">Nuevo usuario: experiencia Premium</h3>
            <p class="mt-2 text-sm leading-relaxed text-white/90">
              Gracias por ser parte de la comunidad. Durante los próximos ${TRIAL_DIAS} días podés acceder a los beneficios de
              <strong class="font-semibold text-white">vendedor nivel 5</strong> (comisión más baja), desde tu primera publicación activa en el barrio.
            </p>
            <div class="mt-4 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
              <button type="button" id="perfil-beneficios" class="mlv-btn-secondary inline-flex w-full flex-1 items-center justify-center rounded-full bg-brand-secondary py-3 text-sm font-bold uppercase tracking-wide text-emerald-950 shadow-md transition hover:brightness-95 sm:min-w-[140px] sm:px-6">
                Ver beneficios
              </button>
              <button type="button" id="perfil-plan-pro" class="inline-flex w-full flex-1 items-center justify-center rounded-full border-2 border-white/70 bg-white/10 py-3 text-sm font-bold text-white shadow-sm backdrop-blur-sm transition hover:bg-white/20 sm:min-w-[140px] sm:px-6">
                Plan Profesional
              </button>
            </div>
          </section>`
          }
        </main>

        <nav class="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200/90 bg-white/95 px-2 pt-2 backdrop-blur-md" style="padding-bottom:max(0.75rem, env(safe-area-inset-bottom))">
          <div class="mx-auto flex max-w-lg items-center justify-around">
            <button type="button" id="nav-explorar" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${mlvNavPng('home')}
              <span class="text-[10px] font-medium">Explorar</span>
            </button>
            ${
              isServiciosNavVisible()
                ? `<button type="button" id="nav-servicios" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${mlvNavPng('servicios')}
              <span class="text-[10px] font-medium">Servicios</span>
            </button>`
                : ''
            }
            <button type="button" id="nav-vender" class="mlv-nav-item flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-slate-500 hover:bg-slate-100">
              ${iconPlusCircle()}
              <span class="text-[10px] font-medium">Vender</span>
            </button>
            <button type="button" id="nav-perfil" class="mlv-nav-active flex flex-1 flex-col items-center gap-1 rounded-xl bg-brand-primary/10 py-2 text-brand-primary">
              ${mlvNavPng('profile')}
              <span class="text-[10px] font-semibold">Mi perfil</span>
            </button>
          </div>
        </nav>
      </div>
    `);

    document.getElementById('perfil-notif')?.addEventListener('click', () => void onNotificaciones?.());
    const btnPwa = document.getElementById('perfil-instalar-pwa');
    if (btnPwa) btnPwa.onclick = () => void onInstalarApp?.();
    wirePerfilAccionBusy('perfil-editar', async () => {
      mlvTrack(MLV_EVENTS.PERFIL_EDITAR);
      await onEditarPerfil?.();
    });
    wirePerfilAccionBusy('perfil-mis-pubs', onMisPublicaciones);
    wirePerfilAccionBusy('perfil-publicar', onPublicar);
    const btnAdmin = document.getElementById('perfil-admin-panel');
    if (btnAdmin) wirePerfilAccionBusy('perfil-admin-panel', onAdminPanel);
    wirePerfilAccionBusy('perfil-logout', async () => {
      mlvTrack(MLV_EVENTS.LOGOUT);
      await onLogout?.();
    }, 'Cerrando sesión…');
    wirePerfilAccionBusy('perfil-beneficios', onVerInfoExperienciaVendedor);
    wirePerfilAccionBusy('perfil-plan-pro', onVerPlanPremiumProfesional);
    document.getElementById('perfil-empuja-comercio')?.addEventListener('click', () => void onEmpujaComercio?.());
    document.getElementById('perfil-servicios-barrio')?.addEventListener('click', () => void onServiciosBarrio?.());
    document.getElementById('perfil-como-barrio')?.addEventListener('click', () => void onComoFuncionaBarrio?.());
    wirePerfilAccionBusy('nav-explorar', onExplorar);
    wirePerfilAccionBusy('nav-servicios', onServiciosBarrio);
    wirePerfilAccionBusy('nav-vender', onVender);
    document.getElementById('nav-perfil').onclick = () => {};

    const fotoInput = document.getElementById('perfil-foto-input');
    const fotoHint = document.getElementById('perfil-foto-hint');
    if (fotoInput && onCambiarFoto) {
      fotoInput.addEventListener('change', async (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file) return;
        fotoInput.disabled = true;
        if (fotoHint) fotoHint.textContent = 'Subiendo foto…';
        mlvTrack(MLV_EVENTS.PERFIL_CAMBIAR_FOTO);
        try {
          await onCambiarFoto(file);
        } finally {
          if (fotoInput.isConnected) fotoInput.disabled = false;
        }
      });
    }
  }

  return { showPerfil };
}
